import config from "../config.js";
import RequestManager from "./request.js";

// Service de la fenetre "Formules & details complementaires" (port de frmSTS.vb).
// Tout le contenu provient de STS_Resultats (sortie du moteur de tarification STS),
// expose par le backend (FSEController : getResultatsSTS / setModifSTS /
// choixFormuleSTS / validerSTS). Voir src/script/STSResultats.js pour le parsing.
export default class STS {
    // Lance la tarification STS (init + recalcul auto) et renvoie les resultats.
    // Reponse : { ok, resultats: [{Type, FieldsCount, Fields[]}], nbResultats }.
    static async getResultats() {
        try {
            const response = await RequestManager.get(`${config.urlBackEnd}FSE/getResultatsSTS`);
            return response;
        } catch (error) {
            console.error("Erreur lors de la recuperation des resultats STS : ", error);
            throw error;
        }
    }

    // Modifie un champ editable d'une grille STS (groupe/champ). Renvoie les
    // resultats mis a jour. data = { IndexResultat, NoChamp, Valeur }.
    static async setModif(data) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}FSE/setModifSTS`, data);
            return response;
        } catch (error) {
            console.error("Erreur lors de la modification d'un champ STS : ", error);
            throw error;
        }
    }

    // Choisit une formule AMC pour un acte. data = { NoPresta, NoFormule }.
    // Renvoie { ok, indexFormule, calculTheorique, resultats, nbResultats }.
    static async choixFormule(data) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}FSE/choixFormuleSTS`, data);
            return response;
        } catch (error) {
            console.error("Erreur lors du choix de formule STS : ", error);
            throw error;
        }
    }

    // Injecte la complementaire (groupes SSV 107/108/109) dans la zone d'entree STS
    // avant getResultats(). input = ComplementaireInput (cf backend). ATTENTION :
    // les champs B2 obligatoires (CodeRoutageFluxAmc, IdentifiantHote, NomDomaineAmc)
    // ne sont PAS portes par le QR AMC -> a resoudre via l'annuaire / validation
    // utilisateur avant d'appeler cette route (sinon zone d'entree STS invalide).
    static async setComplementaire(input) {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}FSE/SetComplementaire`, input);
            return response;
        } catch (error) {
            console.error("Erreur lors du SetComplementaire STS : ", error);
            throw error;
        }
    }

    // Valide la part complementaire (sauvegarde les resultats STS dans la facture).
    static async valider() {
        try {
            const response = await RequestManager.post(`${config.urlBackEnd}FSE/validerSTS`);
            return response;
        } catch (error) {
            console.error("Erreur lors de la validation STS : ", error);
            throw error;
        }
    }
}
